<template>
  <div class="continuingEducation wow bounceInUp">
    <ComList
      :PageSize.sync="PageSize"
      :PageNo.sync="PageNo"
      :Total.sync="Total"
      infoColumn="8"
      baseDetailsUrl="professionalDetails"
      listType=""
    ></ComList>
  </div>
</template>
<script>
import ComList from "../../components/news/comList";
export default {
  data() {
    return {
      Total: 10, // 总数
      PageNo: 1, // 当前页
      PageSize: 5, // 每页显示条数
    };
  },
  mounted() {
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      new this.$wow({
        //默认为true
        live: false,
      }).init();
    });
  },
  methods: {},
  components: { ComList },
};
</script>
<style lang="scss">
$themeMinWidth: 1180px;
.continuingEducation {
  position: relative;
  .comList {
    margin: 30px auto 50px !important;
    &::before {
      content: "";
      position: absolute;
      left: 216px;
    }
  }
}
</style>
